import React from "react";

import { Card, CardBody, Col, Row } from "reactstrap";

import { displayDate, currencyFormat } from "../../../../lib/utils";
import { InvoiceData } from "../../../../types";
import { useHistory } from "react-router-dom";

type PaymentInvoiceCardProps = {
  id: string;
  item: InvoiceData;
};

export const PaymentInvoiceCard: React.FC<PaymentInvoiceCardProps> = ({
  id,
  item,
}) => {
  const { total, dueDate, description } = item;

  const history = useHistory();

  const handleOnClickInvoice = (): void => {
    history.push(`/payment-receipt-detail/${item.id}`);
  };

  return (
    <Card id={id} className="my-2">
      <CardBody onClick={handleOnClickInvoice}>
        <h6 id={`${id}Header`}>{description}</h6>
        <Row>
          <Col id={`${id}Total`}>{`$${currencyFormat(total)}`}</Col>
          <Col
            id={`${id}Date`}
            className="text-right text-primary font-weight-bold">
            {displayDate(dueDate, "ll")}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
